import worldMap from '../../assets/images/World_Map.svg';
import location from "../../assets/icons/Icon_location.svg";

const stats = [
  { number: '150+', label: 'Projects completed' },
  { number: '250+', label: 'eCTD Publishing' },
  { number: '60+', label: 'Clients' },
  { number: '12+', label: 'Countries' },
];

const markerPositions = [
  { top: '30%', left: '20%' },
  { top: '33%', left: '30%' },
  { top: '30%', left: '55%' },
  { top: '25%', left: '65%' },
  { top: '25%', left: '75%' },
  { top: '40%', left: '70%' },
  { top: '70%', left: '30%' },
  { top: '60%', left: '25%' },
  { top: '45%', left: '50%' },
  { top: '40%', left: '60%' },
  { top: '40%', left: '70%' },
  { top: '50%', left: '85%' },
  { top: '40%', left: '80%' },
  { top: '45%', left: '15%' },
  { top: '55%', left: '60%' },
  { top: '22%', left: '51%' },
  { top: '18%', left: '40%' },
];

const AccomplishmentMap = () => {
  return (
    <div className="bg-[linear-gradient(180deg,#05326D_0%,#315584_100%)] text-white py-16 px-6 lg:px-20">
      <div className="max-w-[var(--max-width)] mx-auto flex flex-col lg:flex-row justify-between gap-12">

        {/* Left Section */}
        <div className="w-full lg:w-1/3 space-y-8">
          {/* Heading + Line */}
          <div className="relative inline-block w-fit">
            <h1 className="inline-block relative text-3xl md:text-4xl text-white mb-12 font-normal text-[32px]">
          Our accomplishment
          <span className="absolute right-0 -bottom-2 w-[40px] border-b-[6px] border-[#B5AB28] rounded-[6px]"></span>
        </h1>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-[#05326D] px-6 py-8 rounded-lg shadow-md text-center"
              >
                <p className="text-3xl font-bold text-[#6EC1E4]">{stat.number}</p>
                <p className="text-sm text-white mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Section */}
        <div className="w-full lg:w-2/3 relative">
          {/* Heading + Line */}
          <div className="relative inline-block w-fit mb-1 ml-6 sm:ml-10 md:ml-16 lg:ml-60">
            <h1 className="inline-block relative text-3xl md:text-4xl text-white mb-4 font-normal text-[32px]">
          Empowering Clients Worldwide
          <span className="absolute right-0 -bottom-2 w-[40px] border-b-[6px] border-[#B5AB28] rounded-[6px]"></span>
        </h1>
          </div>

          {/* Map + Location Pins */}
          <div className="relative w-full h-0 pb-[56.25%]">
            <img
              src={worldMap}
              alt="World Map"
              className="absolute top-0 left-0 w-full h-full object-contain"
            />

            {markerPositions.map((pos, index) => (
              <img
                key={index}
                src={location}
                alt="location marker"
                className="absolute w-5 h-5"
                style={{
                  top: pos.top,
                  left: pos.left,
                  transform: 'translate(-50%, -50%)',
                }}
              />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default AccomplishmentMap;
